import React from 'react';
import { _EmptyContainer, _PlaceholderLine } from "./style";
export default function Empty() {
  return /*#__PURE__*/React.createElement(_EmptyContainer, null, /*#__PURE__*/React.createElement(_PlaceholderLine, {
    width: "50%",
    marginBottom: 24
  }), /*#__PURE__*/React.createElement(_PlaceholderLine, {
    width: "100%"
  }), /*#__PURE__*/React.createElement(_PlaceholderLine, {
    width: "70%"
  }));
}